import React from "react";

function AccessibilityStatement() {
  return (
    <div className="accessibilityStatement">
      <h1>Accessibility Statement</h1>
      <p>
        This accessibility statement applies to
        seeitbeit.lifelonglearningandskills.org
      </p>
      <p>
        This website is run by Sheffield City Council. We want as many people as
        possible to be able to use this website. For example, that means you
        should be able to:
      </p>
      <ul>
        <li>change colours, contrast levels and fonts</li>
        <li>zoom in up to 300% without the text spilling off the screen</li>
        <li>navigate most of the website using just a keyboard</li>
        <li>navigate most of the website using speech recognition software</li>
        <li>
          listen to most of the website using a screen reader (including the
          most recent versions of JAWS, NVDA and VoiceOver)
        </li>
        <li>
          We’ve also made the website text as simple as possible to understand.
        </li>
      </ul>
      <p>
        <a
          className="externalLink"
          href="https://mcmw.abilitynet.org.uk/"
          target="_blank"
        >
          AbilityNet
        </a>{" "}
        has advice on making your device easier to use if you have a disability.
      </p>
      <h2>Feedback and contact information</h2>
      <p>
        If you need information on this website in a different format like
        accessible PDF, large print, easy read, audio recording or braille:
      </p>
      <ul>
        <li>
          email{" "}
          <a className="externalLink" href="mailto: seeitbeit@sheffield.gov.uk">
            {" "}
            seeitbeit@sheffield.gov.uk
          </a>
        </li>
        <li>call 0114 474 1595</li>
      </ul>
      <p>We’ll consider your request and get back to you in 10 working days.</p>
      <h2>Reporting accessibility problems with this website</h2>
      <p>
        We’re always looking to improve the accessibility of this website. If
        you find any problems not listed on this page or think we’re not meeting
        accessibility requirements, contact the See it be it in Sheffield team
        on{" "}
        <a className="externalLink" href="mailto: seeitbeit@sheffield.gov.uk">
          {" "}
          seeitbeit@sheffield.gov.uk
        </a>{" "}
      </p>
      <h2>Enforcement procedure</h2>
      <p>
        The Equality and Human Rights Commission (EHRC) is responsible for
        enforcing the Public Sector Bodies (Websites and Mobile Applications)
        (No. 2) Accessibility Regulations 2018 (the ‘accessibility
        regulations’). If you’re not happy with how we respond to your
        complaint, contact the{" "}
        <a
          className="externalLink"
          href="https://www.equalityadvisoryservice.com/"
          target="_blank"
        >
          Equality Advisory and Support Service (EASS).
        </a>
      </p>
      <h2>Contacting us by phone or visiting us in person</h2>
      <p>
        We provide a text relay service for people who are D/deaf, hearing
        impaired or have a speech impediment.
      </p>
      <p>
        Our offices have audio induction loops, or if you contact us before your
        visit we can arrange a British Sign Language (BSL) interpreter.
      </p>
      <p>
        <a
          className="externalLink"
          href="https://seeitbeit.lifelonglearningandskills.org/get-involved/contact-us"
          target="_blank"
        >
          Find out how to contact us.
        </a>
      </p>
      <h2>Technical information about this website’s accessibility</h2>
      <p>
        Sheffield City Council is committed to making its website accessible, in
        accordance with the Public Sector Bodies (Websites and Mobile
        Applications) (No. 2) Accessibility Regulations 2018.
      </p>
      <h2>Compliance status</h2>
      <p>
        This website is partially compliant with the{" "}
        <a
          className="externalLink"
          href="https://www.w3.org/TR/WCAG21/"
          target="_blank"
        >
          Web Content Accessibility Guidelines version 2.1
        </a>{" "}
        AA standard and we are awaiting a full manual audit.
      </p>
      <h2>What we’re doing to improve accessibility</h2>
      <p>
        We continue to develop our guidance for content editors on how to make
        the site content accessible. We have also embedded accessibility into
        our internal processes to ensure all future development has
        accessibility as part of its acceptance criteria.
      </p>
      <p>
        We continue to raise awareness of accessibility and help develop
        training to support services across the organisation.
      </p>
      <h2>Preparation of this accessibility statement</h2>
      <p>
        This statement was prepared on 10 November 2023. It was last reviewed on
        10 November 2023.
      </p>
      <p>
        This website was last tested on 10 November 2023. The test was carried
        out by Sheffield City Council.
      </p>
    </div>
  );
}

export default AccessibilityStatement;
